export const BookingApproved = "BookingApproved"
export const BookingRejected = "BookingRejected" 
export const CustomerResponsePending = "CustomerResponsePending"
export const AlreadyReplied = "AlreadyReplied"